export enum DialogIds {
    ActivateBillingDialog,
    AddLandingPageSubdomain,
    PersonaSurveyDialog,
}
